/**
 * Auth callback page for Zoom OAuth flow
 */
export function Auth(): JSX.Element {
  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="text-center space-y-4 p-8">
        <div className="text-6xl">✓</div>
        <h1 className="text-2xl font-bold text-gray-900">
          Authorization Successful
        </h1>
        <p className="text-gray-600">
          You can close this window and return to Zoom.
        </p>
      </div>
    </div>
  );
}
